 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"npm.mdi":"npm.mdi","home~select":"home~select","home":"home","select":"select","npm.chart.js":"npm.chart.js","npm.chartjs-plugin-datalabels":"npm.chartjs-plugin-datalabels","npm.vue-chartjs":"npm.vue-chartjs"}[chunkId]||chunkId) + "." + {"chunk-2d0a3c8c":"c6744723","chunk-2d0a3e2e":"9c86d25b","chunk-2d0a4fbf":"139b4ac6","chunk-2d0aaf54":"a6e6740e","chunk-2d0ab4bc":"37ce9b48","chunk-2d0b6586":"f12707f0","chunk-2d0b6cae":"2e76b18d","chunk-2d0b9f28":"97541ee9","chunk-2d0be0b0":"bc19ccd3","chunk-2d0c0676":"c45f2ca0","chunk-2d0c2184":"50ec1b1f","chunk-2d0c4fc8":"02182713","chunk-2d0c9017":"2b9f95a7","chunk-2d0d2ba2":"aa54b587","chunk-2d0d403a":"f0367da7","chunk-2d0d640c":"ede14bcc","chunk-2d0d6e57":"4f167309","chunk-2d0dd3f1":"96ec043f","chunk-2d0dd46a":"1dba0008","chunk-2d0dee53":"4f8db9ba","chunk-2d0e1a3c":"742dc22d","chunk-2d0e2903":"ec488862","chunk-2d0e5eb9":"9b436ac8","chunk-2d0e68a3":"ab37757f","chunk-2d207915":"cac6e87b","chunk-2d217eb9":"4439354c","chunk-2d21d856":"4413d423","chunk-2d21dfb8":"e9f0500f","chunk-2d21e73b":"83bd28c8","chunk-2d21f86e":"ebd794f6","chunk-2d224eef":"6999be91","chunk-2d225c47":"4d5dbcd4","chunk-2d2263d7":"946b06cf","chunk-2d2264db":"ed7a7af8","chunk-2d229637":"add40af7","chunk-2d237d34":"185d2af0","npm.mdi":"e3683e0a","home~select":"675c705e","home":"245b3322","select":"3d53de5f","npm.chart.js":"9ab49b5c","npm.chartjs-plugin-datalabels":"7b2fbebf","npm.vue-chartjs":"49754535","chunk-2d0d36b6":"58d4f6e0","chunk-e394ddc4":"c30c03b1","chunk-2d0dd80c":"7ed62091","chunk-2d0d6ba2":"2dfe194f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"home~select":1,"home":1,"select":1,"chunk-e394ddc4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.mdi":"npm.mdi","home~select":"home~select","home":"home","select":"select","npm.chart.js":"npm.chart.js","npm.chartjs-plugin-datalabels":"npm.chartjs-plugin-datalabels","npm.vue-chartjs":"npm.vue-chartjs"}[chunkId]||chunkId) + "." + {"chunk-2d0a3c8c":"31d6cfe0","chunk-2d0a3e2e":"31d6cfe0","chunk-2d0a4fbf":"31d6cfe0","chunk-2d0aaf54":"31d6cfe0","chunk-2d0ab4bc":"31d6cfe0","chunk-2d0b6586":"31d6cfe0","chunk-2d0b6cae":"31d6cfe0","chunk-2d0b9f28":"31d6cfe0","chunk-2d0be0b0":"31d6cfe0","chunk-2d0c0676":"31d6cfe0","chunk-2d0c2184":"31d6cfe0","chunk-2d0c4fc8":"31d6cfe0","chunk-2d0c9017":"31d6cfe0","chunk-2d0d2ba2":"31d6cfe0","chunk-2d0d403a":"31d6cfe0","chunk-2d0d640c":"31d6cfe0","chunk-2d0d6e57":"31d6cfe0","chunk-2d0dd3f1":"31d6cfe0","chunk-2d0dd46a":"31d6cfe0","chunk-2d0dee53":"31d6cfe0","chunk-2d0e1a3c":"31d6cfe0","chunk-2d0e2903":"31d6cfe0","chunk-2d0e5eb9":"31d6cfe0","chunk-2d0e68a3":"31d6cfe0","chunk-2d207915":"31d6cfe0","chunk-2d217eb9":"31d6cfe0","chunk-2d21d856":"31d6cfe0","chunk-2d21dfb8":"31d6cfe0","chunk-2d21e73b":"31d6cfe0","chunk-2d21f86e":"31d6cfe0","chunk-2d224eef":"31d6cfe0","chunk-2d225c47":"31d6cfe0","chunk-2d2263d7":"31d6cfe0","chunk-2d2264db":"31d6cfe0","chunk-2d229637":"31d6cfe0","chunk-2d237d34":"31d6cfe0","npm.mdi":"31d6cfe0","home~select":"97b2fa96","home":"9a3c1988","select":"cfb9d892","npm.chart.js":"31d6cfe0","npm.chartjs-plugin-datalabels":"31d6cfe0","npm.vue-chartjs":"31d6cfe0","chunk-2d0d36b6":"31d6cfe0","chunk-e394ddc4":"cdc87e6d","chunk-2d0dd80c":"31d6cfe0","chunk-2d0d6ba2":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/growth/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.vuetify","npm.core-js","npm.vue-i18n","npm.vue-loader","npm.vue-router","npm.vue","npm.vuex-router-sync","npm.vuex","npm.webpack"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
